// src/components/BlogPostDetail.jsx

import React, { useState, useEffect } from 'react';
// NOTE: Assuming contentfulClient is configured correctly in this path
import contentfulClient from '../contentfulClient'; 
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

// *** ADJUST THIS ID TO MATCH THE API ID OF YOUR Contentful Content Model ***
const BLOG_POST_CONTENT_TYPE_ID = 'blogPost'; 

// Accept postSlug AND the new onPostLoaded callback function
function BlogPostDetail({ postSlug, onPostLoaded }) { 
  const [post, setPost] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!postSlug) return; 

    const fetchBlogPost = async () => {
      setIsLoading(true);
      setError(null);
      
      try {
        const response = await contentfulClient.getEntries({ 
           content_type: BLOG_POST_CONTENT_TYPE_ID, 
           'fields.slug': postSlug, 
           include: 1, 
           limit: 1 
        });

        const postData = response.items[0]; 

        if (postData) {
          const fields = postData.fields || {};
          const authorRef = fields.author?.fields || {}; 
          const authorName = authorRef.name || 'Anonymous';
          
          // --- START CHANGE 1: Extract Image URL ---
          const imageUrl = fields.featuredImage
            ? `https:${fields.featuredImage.fields.file.url}`
            : null;

          const newPost = {
            title: fields.title,
            date: new Date(fields.publishDate).toLocaleDateString(),
            author: authorName,
            body: fields.body,
            imageUrl: imageUrl, // <-- New field added
          };
          // --- END CHANGE 1: Extract Image URL ---
          
          setPost(newPost);
          
          // CRITICAL: Call the parent's function with the fetched title
          if (onPostLoaded && newPost.title) {
            console.log("Child sending title:", newPost.title)
              onPostLoaded(newPost.title);
          }
          
        } else {
          setPost(null); 
          // If not found, tell the parent to use the generic fallback title (or clear the title)
          if (onPostLoaded) {
              onPostLoaded(null); 
          }
        }
      } catch (err) {
        console.error("Contentful Fetch Error on Detail Page:", err);
        setError("Failed to load post. Check Contentful slug and connection.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchBlogPost();
  }, [postSlug, onPostLoaded]); 

  // ... (Loading, Error, Not Found JSX) ...
  if (isLoading) {
    return <div id="blog-page" className="container mt-5 text-center">Loading Post...</div>;
  }
  if (error) {
    return <div id="blog-page" className="container mt-5 text-danger text-center">Error: {error}</div>;
  }
  if (!post) {
    return <div id="blog-page" className="container mt-5 text-center">Post with slug "{postSlug}" not found.</div>;
  }
  
  return (
    // We remove the 'container' class from <main> to allow the image to span full width, 
    // and instead wrap the content in a container below the image.
    <main id="blog-page" className="">
      <div className="container mt-5 pt-5">
        <div className="row g-5 justify-content-center">
          <div className="col-md-8">
                     {/* --- START CHANGE 2: Banner Image Component --- */}
      {post.imageUrl && (
        <div 
          className="blog-banner-image" 
          style={{
            backgroundImage: `url(${post.imageUrl})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            height: '350px', // Adjust this height as needed for your banner
            marginBottom: '3rem', // Add space below the banner
          }}
          aria-label={`Featured image for ${post.title}`}
        >
          {/* Optional overlay for better text readability if you move title here */}
        </div>
      )}
      {/* --- END CHANGE 2: Banner Image Component --- */}
            <article className="blog-post">
              <h1 className="blog-post-title display-4">{post.title}</h1>
              <p className="blog-post-meta">{post.date} by {post.author}</p>

              {/* Render the Rich Text body content */}
              <div className="contentful-rich-text">
                  {documentToReactComponents(post.body)}
              </div>
            </article>
          </div>
          {/* You might place a sidebar here in a col-md-4 */}
        </div>
      </div>
    </main>
  );
}

export default BlogPostDetail;